import React, { memo } from 'react';
import { isEqual } from 'lodash';
import PropTypes from 'prop-types';
import { Store } from 'react-notifications-component';
import { Cell, Row } from '../../../../../../components/Table/Grid';
import {
  checkedAdd,
  checkedAddShift,
  checkedDelete,
  checkedDeleteShift,
  modalOpen,
  resendSubscription,
  resendSubscriptionSuccess,
} from '../../../reducer';
import { getHighlightingText } from '../../../../../../utils/helper';
import ServiceId from '../../../../../../components/Badge/ServiceId';
// eslint-disable-next-line import/no-named-as-default
import PostCount from './PostCount';
import Dropdown from '../../../../../../components/Dropdown/Default';
import * as modals from '../../../constants/modals';
import { STATUSES } from '../../../constants/statuses';
import { subscriptionsResend } from '../../../../../../services/endpoints/subscriptions';
import { getErrorMessage } from '../../../../../Services/Main/helpers/getters';
import { RESEND } from '../../../constants/actions';

const SubscriptionsTableBodyRow = (props) => {
  const {
    id,
    index,
    items,
    submenuStatuses,
    delayName,
    search,
    searchType,
    user,
    user_name,
    quantity,
    new_posts,
    old_posts,
    service_id,
    service_name,
    status,
    status_name,
    provider_order_id,
    expiry,
    created,
    updated,
    configAccess,
    isChecked,
    lastRow,
    dispatch,
  } = props;
  const onChecked = (e) => {
    const shift = !!e.nativeEvent.shiftKey;
    if (isChecked) {
      shift ? dispatch(checkedDeleteShift(id, index)) : dispatch(checkedDelete(id, index))
      return;
    }
    shift ? dispatch(checkedAddShift(id, index)) : dispatch(checkedAdd(id, index))
  }

  const onResend = async () => {
    try {
      dispatch(resendSubscription())
      await subscriptionsResend(id);
      dispatch(resendSubscriptionSuccess())
    } catch (error) {
      const errorMessage = getErrorMessage(error);
      Store.addNotification({
        title: 'Error',
        message: errorMessage,
        type: 'danger',
        insert: 'top',
        container: 'bottom-right',
        animationIn: ['animate__animated', 'animate__fadeIn'],
        animationOut: ['animate__animated', 'animate__fadeOut'],
        dismiss: {
          duration: 3000,
        },
      });
    }
  }
  const onChangeAction = (actionKey) => {
    if (actionKey) {
      switch (actionKey) {
      case STATUSES.ACTIVE.code:
      case STATUSES.FINISHED.code:
      case STATUSES.PAUSE.code:
        dispatch(modalOpen(modals.CHANGE_STATUS, {
          id,
          status_code: actionKey.toUpperCase(),
        }))
        break;
      case STATUSES.STOPPED.code: {
        dispatch(modalOpen(modals.CANCEL, {
          id,
          status_code: actionKey.toUpperCase(),
        }))
        break;
      }
      case modals.DETAILS: {
        dispatch(modalOpen(modals.DETAILS, {
          id,
        }))
        break;
      }
      case modals.FAIL_DETAILS: {
        dispatch(modalOpen(modals.FAIL_DETAILS, {
          id,
        }))
        break;
      }
      case modals.ERROR_DETAILS: {
        dispatch(modalOpen(modals.ERROR_DETAILS, {
          id,
        }))
        break;
      }
      case modals.EDIT_EXPIRY: {
        dispatch(modalOpen(modals.EDIT_EXPIRY, {
          id,
          expiry,
        }))
        break;
      }
      case RESEND: {
        onResend();
        break;
      }
      default:
      }
    }
  }

  const isDisabledCheckbox = status === 3;

  return (
    <Row hover bg={isChecked}>
      {configAccess.change_statuses ? (
        <Cell height="md" borderBottom={lastRow ? 'none' : 'xs'} style={{ minWidth: 42, width: 42 }}>
          <div className="d-flex justify-center">
            <input type="checkbox" onChange={onChecked} checked={isChecked} disabled={isDisabledCheckbox} className="m-0 cursor-pinter" />
          </div>
        </Cell>
      ) : null }
      <Cell borderBottom={lastRow ? 'none' : 'xs'} paddingX={configAccess.change_statuses ? 'sm' : 'md'} style={{ whiteSpace: 'nowrap' }}>
        <div style={{ height: provider_order_id ? '16px' : 'auto' }} dangerouslySetInnerHTML={getHighlightingText(id, search, (searchType === 1 || searchType === null))} />
        {provider_order_id ? <div className="grey orders-pay-hash"><small><div dangerouslySetInnerHTML={getHighlightingText(provider_order_id, search, (searchType === 4 || searchType === null))} /></small></div> : null}
      </Cell>
      <Cell borderBottom={lastRow ? 'none' : 'xs'} style={{ minWidth: 50, width: 50 }}>
        <div dangerouslySetInnerHTML={getHighlightingText(user, search, (searchType === 2 || searchType === null))} />
      </Cell>
      <Cell borderBottom={lastRow ? 'none' : 'xs'} style={{ minWidth: 50, width: 220 }}>
        <div dangerouslySetInnerHTML={getHighlightingText(user_name, search, (searchType === 3 || searchType === null))} />
      </Cell>
      <Cell borderBottom={lastRow ? 'none' : 'xs'} style={{ minWidth: 50, width: 50 }}>
        {quantity.min}
        {' '}
        —
        {' '}
        {quantity.max}
      </Cell>
      <Cell borderBottom={lastRow ? 'none' : 'xs'} style={{ minWidth: 50, width: 50 }}>
        <PostCount value={new_posts.done} url={new_posts.url} />
        {' '}
        /
        {' '}
        <PostCount value={new_posts.total} />
      </Cell>
      <Cell borderBottom={lastRow ? 'none' : 'xs'} style={{ minWidth: 50, width: 50 }}>
        <PostCount value={old_posts.done} url={old_posts.url} />
        {' '}
        /
        {' '}
        <PostCount value={old_posts.total} />
      </Cell>
      {configAccess.delays
        ? (
          <Cell borderBottom={lastRow ? 'none' : 'xs'} style={{ minWidth: 50, width: 50 }}>
            {delayName}
          </Cell>
        ) : null }
      {configAccess.services
        ? (
          <Cell borderBottom={lastRow ? 'none' : 'xs'} style={{ minWidth: 120, width: 400 }}>
            <ServiceId>
              <div dangerouslySetInnerHTML={getHighlightingText(service_id, search, (searchType === 4 || searchType === null))} />
            </ServiceId>
            {' '}
            {service_name}
          </Cell>
        ) : null }
      <Cell borderBottom={lastRow ? 'none' : 'xs'} style={{ minWidth: 80, width: 80 }}>
        {status_name}
      </Cell>
      <Cell borderBottom={lastRow ? 'none' : 'xs'} style={{ minWidth: 86, width: 86 }}>
        {created.split(' ').map((date, i) => (
          <span key={i} className="nowrap">
            {date}
          </span>
        ))}
      </Cell>
      <Cell borderBottom={lastRow ? 'none' : 'xs'} style={{ minWidth: 86, width: 86 }}>
        {updated.split(' ').map((date, i) => (
          <span key={i} className="nowrap">
            {date}
          </span>
        ))}
      </Cell>
      <Cell borderBottom={lastRow ? 'none' : 'xs'} style={{ minWidth: 120, width: 120 }}>
        {expiry}
      </Cell>
      <Cell borderBottom={lastRow ? 'none' : 'xs'} style={{ minWidth: 50, width: 50 }} paddingY="md" paddingX="md" alignHorizontal="right">
        {items.length
          ? (
            <Dropdown
              handleSelect={onChangeAction}
              size="xsmall"
              title="Actions"
              items={items}
              forMassActions
              classForBtnDrop="font__weight-med"
              dropStyle="default"
              toolbarClass="dropdown-right"
              submenuStatuses={submenuStatuses}
              submenuPlacement="left"
              id={id}
              item={props}
            />
          ) : null}

      </Cell>
    </Row>
  )
};

const arePropsEqual = (prevProps, nextProps) => isEqual(prevProps, nextProps);

SubscriptionsTableBodyRow.propTypes = {
  id: PropTypes.number,
  index: PropTypes.number,
  search: PropTypes.string,
  searchType: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isChecked: PropTypes.bool,
  lastRow: PropTypes.bool,
  items: PropTypes.array,
  submenuStatuses: PropTypes.array,
  delayName: PropTypes.string,
  user: PropTypes.string,
  user_name: PropTypes.string,
  quantity: PropTypes.object,
  new_posts: PropTypes.object,
  old_posts: PropTypes.object,
  service_id: PropTypes.number,
  service_name: PropTypes.string,
  status: PropTypes.number,
  status_name: PropTypes.string,
  provider_order_id: PropTypes.number,
  expiry: PropTypes.string,
  created: PropTypes.string,
  updated: PropTypes.string,
  configAccess: PropTypes.object,
  dispatch: PropTypes.func,
}

export default memo(SubscriptionsTableBodyRow, arePropsEqual);
